<template>
  <Teleport to="#modals" :tag="portalTag" :disabled="noGlobal">
    <!-- <transition name="fade"> -->
    <div
      ref="main"
      class="gp_modal"
      :class="classs"
      v-bind="inheritScopeIds"
      @mousedown.self="handleCancel"
      @keyup.esc="handleCancel">
      <div v-if="!noBackdrop" class="gp_modal-backdrop" @mousedown.prevent="overlayClick"></div>
      <div
        v-click-away="onOutSize"
        class="gp_modal-container"
        :class="[cClass, padding]"
        @mousedown.left.self="$emit('container')">
        <div v-if="!hideExit" class="gp_modal-close" :class="closeClass" @click.prevent="handleCancel">
          <i class="icon icon-cancel" :class="iClass"></i>
        </div>
        <template v-if="hasHeader">
          <header class="gp_modal-container_header" :class="hClass">
            <slot name="header"></slot>
          </header>
          <hr v-if="!breakLine" class="bg-dark-high" />
        </template>
        <header v-if="hasActions" class="gp_modal-container_actions" :class="aClass">
          <slot name="actions"></slot>
        </header>
        <section
          v-if="hasBody"
          class="gp_modal-container_body"
          :class="[mClass, { 'overflow-hidden': overflowHidden }]">
          <slot></slot>
        </section>
        <footer v-if="hasFooter" class="gp_modal-container_footer mt-auto" :class="fClass">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
    <!-- </transition> -->
  </Teleport>
</template>

<script>
import scopeAttr from '@/mixins/scopeAttr.ts';
export default {
  name: 'Modal',
  mixins: [scopeAttr],
  props: {
    aClass: String,
    cClass: String,
    hClass: {
      type: String,
      default: 'p-4 pb-2',
    },
    iClass: {
      type: String,
      default: '',
    },
    closeClass: {
      type: String,
      default: 'p-1',
    },
    mClass: {
      type: String,
      default: 'p-4 pt-3',
    },
    fClass: {
      type: String,
      default: 'p-4 pt-0',
    },
    padding: {
      type: String,
    },
    noBackdrop: {
      type: Boolean,
      default: false,
    },
    hideExit: {
      type: Boolean,
      default: true,
    },
    breakLine: {
      type: Boolean,
      default: false,
    },
    preventBackdrop: {
      type: Boolean,
      default: false,
    },
    classs: String,
    scopeIds: {
      type: Array,
      default: () => [],
    },
    noGlobal: {
      type: Boolean,
      default: false,
    },
    overflowHidden: {
      type: Boolean,
      default: false,
    },
    portalTag: {
      type: String,
      default: 'div',
    },
  },
  emits: ['outsize', 'cancel', 'container'],
  computed: {
    hasHeader() {
      return !!this.$slots['header'];
    },
    hasActions() {
      return !!this.$slots['actions'];
    },
    hasBody() {
      return !!this.$slots['default'];
    },
    hasFooter() {
      return !!this.$slots['footer'];
    },
    inheritScopeIds() {
      const output = {
        ...this.scopeAttrs,
      };
      if (this.scopeIds?.length) {
        this.scopeIds.forEach((key) => {
          output[key] = '';
        });
      }
      return output;
    },
  },
  methods: {
    onOutSize() {
      this.$emit('outsize');
    },
    handleCancel() {
      this.$emit('cancel');
    },
    overlayClick() {
      if (this.preventBackdrop) {
        return;
      }
      this.handleCancel();
    },
  },
};
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

$baseIndex: $modalIndex;
.width-85 {
  width: 85%;
}

.gp_modal {
  position: fixed;
  z-index: $baseIndex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @include flex-center;

  &-backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background: rgba(#000, 0.5);
  }

  &-container {
    position: relative;
    background: $light3;
    min-width: 424px;
    @media screen and (max-width: 576px) {
      min-width: unset;
    }
    max-height: 100vh;
    // height: 600px;
    display: flex;
    z-index: 10;
    flex-direction: column;
    border-radius: $radius;

    &_header {
      position: relative;
      // align-items: center;
      // display: flex;
    }

    &_actions {
      position: relative;
    }

    &_body {
      max-height: calc(100vh - 160px);
      overflow: overlay;
      @-moz-document url-prefix() {
        overflow: auto;
      }
      &.overflow-hidden {
        overflow: hidden;
      }
    }
  }

  &-close {
    z-index: 1;
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    @include flex-center;
    // padding: 15px;
    // @include trans-all;
    color: $text-light-low;
    margin-left: auto;

    font-size: 18px;
    cursor: pointer;
    border-radius: $radius;
    // background: $light3;
    width: 24px;
    height: 24px;
    top: 24px;
    right: 24px;
    &:hover {
      color: $text-light-high;
      background-color: rgba($dark0, 0.1);
    }
  }

  hr {
    margin: 0;
    height: 1px;
    background-color: rgba($black3, 0.1);
  }
}

.preview-template {
  padding: 0 !important;
  width: 100%;
  height: 100vh;
  border-radius: inherit;
  .index-0 {
    z-index: 0;
  }
  .gp_modal-container {
    &_body {
      max-height: unset;
      overflow: unset;
    }
  }
}

.height-unlimit {
  max-height: unset;
  overflow: unset;
}

.btn-select-template {
  padding: 15px 20px;
}

.w93p {
  width: 93%;
  position: relative;
}

.bg-white {
  background: white;
}

.app-details-close {
  top: 24px;
  right: 24px;
}

.feature-promotion {
  filter: drop-shadow(0px -4px 16px rgba(0, 0, 0, 0.06)) drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.12));
  border-radius: 4px;
  max-height: unset;
}
.onboarding-global-style {
  @media (max-width: 1300px) {
    margin-left: 264px !important;
  }
  @media (max-height: 624px) {
    margin-top: 90px !important;
  }
}
</style>
